// ts-nocheck
import React, { useEffect, useReducer, useRef, useState, ReactNode } from "react";
import {InfoBtn} from '../../pages/settings/components/info.btn.js';

// Interface for component props
interface BlockProps {
	tools?: boolean;
	purchase?: boolean;
	account?: boolean;
	changePas?: boolean;
	hidden?: boolean;
	widthWrapPlan?: boolean;
	jcCenter?: boolean;
	title?: string;
	description?: string;
	display?: boolean;
	infoBtn?: wts_ignore_any;
	displayInfo?: wts_ignore_any;
	confirm?: wts_ignore_any;
	block?: boolean;
	onClick?: () => void;
	titleBtn?: string;
	children?: ReactNode;
}

export const Block = ( props: BlockProps ) => {

	return (
		<section className={"block" +
			( props.tools ? " block-bg": " ") +
			( props.purchase ? " width-purchase": " ")+
			( props.account ? " account-frame": " ") +
			( props.changePas ? " change-pas": " ") +
			( props.hidden ? " hidden": " ")+
			( props.widthWrapPlan ? " width-wrap-plan": " ")
		}>
			<div className={"block-title-wrap" + (props.jcCenter ? " jc-center" : " ")}>
				<p className={"block-title"}>
					<span  className={"block-title-head"}>{ props.title || "" }</span>
					<span  className={"block-title-subhead"}>{ props.description || "" }</span>
				</p>
				{
					(props.display ?
						(<InfoBtn display={props.display} infoBtn={props.infoBtn} displayInfo={props.displayInfo} confirm={props.confirm}/>)
						:
						(null)
					)
				}
			</div>
			<div className={"btn-wrap" + (props.block ? " display-flex" : " hidden")}>
				<div  className={"btn-wrap-item"} onClick={props.onClick}>{ props.titleBtn}</div>
			</div>
			{
				props.children
			}
		</section>
	);
};